import ConfigOffersApi from "../configs/ConfigOffersApi";
import Cookies from "js-cookie";

// The offers service is a Yii2 REST API. The public /api/v1/questions endpoint
// is read-only (PUT/POST there return 405); full CRUD lives under /admin.
const alias = "/admin/questions";

const headers = () => ({ Authorization: Cookies.get("adminToken") });

// List — Yii2 pagination: 1-based `page`, `per-page`; total comes back in the
// X-Pagination-Total-Count response header (exposed via CORS).
const getQuestions = (params) =>
  ConfigOffersApi.get(alias, { params, headers: headers() });

const getQuestion = (id) =>
  ConfigOffersApi.get(`${alias}/${id}`, { headers: headers() });

const createQuestion = (data) =>
  ConfigOffersApi.post(alias, data, { headers: headers() });

const updateQuestion = (id, data) =>
  ConfigOffersApi.put(`${alias}/${id}`, data, { headers: headers() });

const deleteQuestion = (id) =>
  ConfigOffersApi.delete(`${alias}/${id}`, { headers: headers() });

// Image uploads — mirror the legacy service-offers-sdk UploadClient: multipart
// POST to the admin upload endpoints, response carries the stored name in
// `file_name`. The SDK used the original filename as the multipart field name,
// so we replicate that. Content-Type is left to the browser so the multipart
// boundary is set automatically.
const uploadImage = (url, file) => {
  const fd = new FormData();
  fd.append(file.name, file, file.name);
  return ConfigOffersApi.post(url, fd, { headers: headers() });
};

const uploadQuestionImage = (file) =>
  uploadImage("/admin/upload/question-image", file);

const uploadAnswerImage = (file) =>
  uploadImage("/admin/upload/answer-image", file);

export default {
  getQuestions,
  getQuestion,
  createQuestion,
  updateQuestion,
  deleteQuestion,
  uploadQuestionImage,
  uploadAnswerImage,
};
